module.exports = ".timesheetContainer {\n    margin-left: 251px;\n    font-size: 12px;\n    color: #4b4a4a;\n    height: calc(100% - 20px);\n}\n.selectedNodeHierarchy {\n    font-weight: bold;\n    font-size: 13px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/timesheet/timesheet.component.css
// module id = ./src/app/view/timesheet/timesheet.component.css
// module chunks = main